import React from 'react';
import { observer } from 'mobx-react';
import SweetAlert from 'react-bootstrap-sweetalert';

import { constants } from '../../../config';
import { HomeNavbar } from '../../../common/home-navbar';
import { Footer } from '../../../common/footer';
import { routeNaming, AppLink, AppRedirect } from '../../../routes';
import { SessionStore } from '../../../stores/SessionStore';
import { ScreenStore } from '../../../stores/ScreenStore';
import { CheckoutStore } from '../../../stores/CheckoutStore';
import { USER_TYPES } from '../../../models/User';
import { MyAccountMenu } from '../../../pages/my-account/my-account-menu';
import { Spinner } from '../../../common/spinner';
import { CheckoutCard, BUTTON_TYPES } from '../../../common/checkout-card';
import UpArrowIcon from '../../../assets/images/icon-drop-up.svg';
import DownArrowIcon from '../../../assets/images/icon-drop-down.svg';
import { Modal } from '../../../common/modal';
import { SimpleButton } from '../../../common/simple-button';
import styles from './MyOrders.css';
import { ERROR_CODES } from '../../../models/ApiError';
import { ComplexRadioBullet } from '../../../common/complex-radio-bullet';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';
import * as bankImgs from '../../../assets/images';
import { SEO } from '../../../common/seo';

class MyOrders extends React.Component {
  constructor(props) {
    super(props);
    const paymentMethods = ConfigParametersStore.parameters.paymentMethods
      .filter(item => item.typeReference === 1);
    let banks = [];
    if (paymentMethods.length > 0) {
      banks = paymentMethods[0].references || [];
    }
    this.state = {
      actualCheckoutsCollapsed: true,
      pastCheckoutsCollapsed: true,
      showCancelModal: false,
      checkoutId: null,
      promptSelectBank: false,
      bankSelected: null,
      banks,
      paramsBank: null,
    };
    this.buttonBank = React.createRef();
    this._toggleActualCheckoutsCollapse = this._toggleActualCheckoutsCollapse.bind(this);
    this._togglePastCheckoutsCollapse = this._togglePastCheckoutsCollapse.bind(this);
    this._showCancelOrder = this._showCancelOrder.bind(this);
    this._closeCancelModal = this._closeCancelModal.bind(this);
    this._cancelCheckout = this._cancelCheckout.bind(this);
    this._toggleErrorButton = this._toggleErrorButton.bind(this);
    this._toggleSuccessButton = this._toggleSuccessButton.bind(this);
    this._closePayModal = this._closePayModal.bind(this);
    this._selectBank = this._selectBank.bind(this);
    this._performPayment = this._performPayment.bind(this);
    this._showBilling = this._showBilling.bind(this);
  }

  static renderPaymentBankTopMessage(bank) {
    return (
      <React.Fragment>
        <h4 className={styles.paymentDescription} style={{ display: 'flex', alignItems: 'center' }}>
          <span>{bank.name}</span>
          <img style={{ width: 60, marginLeft: 10 }} className={styles.fullPrice} alt="Bank" src={bankImgs[String(bank.name).toLocaleLowerCase().trim().replace(/\s/g, '')]} />
        </h4>
      </React.Fragment>
    );
  }

  componentDidMount() {
    CheckoutStore.getCheckouts();
  }

  componentWillUnmount() {
    CheckoutStore.clearMyOrdersObservables();
  }

  _toggleActualCheckoutsCollapse() {
    this.setState(prevState => (
      {
        actualCheckoutsCollapsed: !prevState.actualCheckoutsCollapsed,
      }
    ));
  }

  _togglePastCheckoutsCollapse() {
    this.setState(prevState => (
      {
        pastCheckoutsCollapsed: !prevState.pastCheckoutsCollapsed,
      }
    ));
  }

  _showBilling(token) {
    console.log(this);
    window.location = `billing-detail?token=${token}`;
  }

  _showCancelOrder(event, type, checkoutId) {
    event.preventDefault();

    if (type.includes(BUTTON_TYPES.CANCEL)) {
      this.setState({
        showCancelModal: true,
        checkoutId,
      });
    } else if (type.includes(BUTTON_TYPES.PAY)) {
      this.setState({
        promptSelectBank: true,
        checkoutId,
      });
    }
  }

  _selectBank(id) {
    this.setState({
      bankSelected: id,
    });
  }

  async _performPayment() {
    if (!this.state.bankSelected) {
      return;
    }
    this.setState({
      promptSelectBank: false,
    });
    await CheckoutStore.attempPay(this.state.checkoutId, this.state.bankSelected.id);
    if (CheckoutStore.checkout) {
      this.setState({
        paramsBank: CheckoutStore.checkout.requestBank,
      }, () => this.buttonBank.current.click());
    } else {
      this.setState({
        showCancelModal: Boolean(CheckoutStore.creationError),
        checkoutId: null,
        bankSelected: null,
      });
    }
  }

  _closePayModal() {
    this.setState({
      promptSelectBank: false,
      checkoutId: null,
      bankSelected: null,
    });
  }

  _closeCancelModal(event) {
    event.preventDefault();

    this.setState({
      showCancelModal: false,
      checkoutId: null,
    });
  }

  _toggleErrorButton(event) {
    event.preventDefault();

    this.setState({
      showCancelModal: false,
      checkoutId: null,
    });

    CheckoutStore.clearCancelErrors();
  }

  _toggleSuccessButton(event) {
    event.preventDefault();

    this.setState({
      showCancelModal: false,
    });

    CheckoutStore.clearCancelSuccess();
  }

  async _cancelCheckout(event) {
    event.preventDefault();

    await CheckoutStore.cancelCheckout(this.state.checkoutId);
    if (CheckoutStore.cancelSuccess) {
      this.setState({
        checkoutId: null,
      });
    }
  }

  render() {
    if (!SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }

    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;

    let dataLoaded = CheckoutStore.actualCheckouts !== null
      || CheckoutStore.pastCheckouts !== null || CheckoutStore.creationLoading === false;

    if (CheckoutStore.creationLoading) {
      dataLoaded = false;
    }

    return (
      <div className={styles.container}>
        <SEO
          title="Mis Compras"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          {
            !mobileVersion &&
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Mi Cuenta</h1>
              <h2 className={styles.subtitle}>
                <span>Hola, </span>
                {SessionStore.user.type === USER_TYPES.COMPANY ?
                  SessionStore.user.fictitiousName :
                  SessionStore.user.names}
                !
              </h2>
            </div>
          }
          {
            mobileVersion &&
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE}
              >
                Mi Cuenta
              </AppLink>
              <span> &gt; Mis Compras</span>
            </p>
          }
          <div className={styles.content}>
            {
              !mobileVersion && <MyAccountMenu indexSelectedItem={4} />
            }
            <div className={styles.myOrdersContainer}>
              <div className={styles.headerContainer}>
                <h2 className={styles.header}>
                  Mis Compras
                </h2>
              </div>
              {
                this.state.promptSelectBank &&
                <SweetAlert
                  title="Seleccione el banco"
                  showCancel
                  confirmBtnText="Pagar"
                  confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
                  cancelBtnText="Cancelar"
                  cancelBtnCssClass={`${styles.btnNoAccept} ${styles.btn}`}
                  placeHolder="Write something"
                  onConfirm={this._performPayment}
                  onCancel={this._closePayModal}
                  closeOnClickOutside={false}
                  style={{
                    width: '100%',
                    left: 0,
                    right: 0,
                    maxWidth: '500px',
                    margin: '0 auto',
                    top: '30%',
                  }}
                >
                  <p>
                    Seleccione uno de los siguientes bancos para
                    efecturar el pago
                  </p>
                  {
                    this.state.banks.map(item => (
                      <div>
                        <ComplexRadioBullet
                          key={item.id}
                          onClick={() => this._selectBank(item)}
                          selected={this.state.bankSelected &&
                            this.state.bankSelected.id === item.id}
                          topMessage={
                            MyOrders.renderPaymentBankTopMessage(item)
                          }
                        />
                      </div>
                    ))
                  }
                </SweetAlert>
              }
              {
                dataLoaded &&
                <div>
                  {
                    !!CheckoutStore.actualCheckouts &&
                    CheckoutStore.actualCheckouts.length !== 0 &&
                    <div>
                      <button
                        className={styles.checkoutsButton}
                        onClick={this._toggleActualCheckoutsCollapse}
                      >
                        Compras Actuales ({CheckoutStore.actualCheckouts.length})
                        {
                          this.state.actualCheckoutsCollapsed ?
                            <img className={styles.arrow} src={DownArrowIcon} alt="" />
                            :
                            <img className={styles.arrow} src={UpArrowIcon} alt="" />
                        }
                      </button>
                      {
                        !this.state.actualCheckoutsCollapsed &&
                        CheckoutStore.actualCheckouts.map((checkout) => {
                          const buttons = [];
                          if (checkout.cancellable) {
                            buttons.push(BUTTON_TYPES.CANCEL);
                          }
                          if (checkout.payable) {
                            buttons.push(BUTTON_TYPES.PAY);
                          }
                          if (checkout.tokenBilling) {
                            buttons.push(BUTTON_TYPES.SHOW_BILLING);
                          }
                          return (
                            <CheckoutCard
                              key={checkout.id}
                              buttonTypes={buttons}
                              onButtonClick={checkout.cancellable || checkout.payable ?
                                this._showCancelOrder : this._showBilling}
                              checkout={checkout}
                              className={styles.checkoutCard}
                            />
                          );
                        })
                      }
                    </div>
                  }
                  {
                    !!CheckoutStore.pastCheckouts &&
                    CheckoutStore.pastCheckouts.length !== 0 &&
                    <div
                      className={!!CheckoutStore.actualCheckouts &&
                        CheckoutStore.actualCheckouts.length !== 0 ? styles.pastCheckoutsContainer : ''}
                    >
                      <button
                        className={styles.checkoutsButton}
                        onClick={this._togglePastCheckoutsCollapse}
                      >
                        Compras Anteriores ({CheckoutStore.pastCheckouts.length})
                        {
                          this.state.pastCheckoutsCollapsed ?
                            <img className={styles.arrow} src={DownArrowIcon} alt="" />
                            :
                            <img className={styles.arrow} src={UpArrowIcon} alt="" />
                        }
                      </button>
                      {
                        !this.state.pastCheckoutsCollapsed &&
                        CheckoutStore.pastCheckouts.map((checkout) => {
                          const buttons = [];
                          if (checkout.cancellable) {
                            buttons.push(BUTTON_TYPES.CANCEL);
                          }
                          if (checkout.payable) {
                            buttons.push(BUTTON_TYPES.PAY);
                          }
                          buttons.push(BUTTON_TYPES.SHOW_BILLING);
                          return (
                            <CheckoutCard
                              key={checkout.id}
                              buttonTypes={buttons}
                              onButtonClick={checkout.cancellable || checkout.payable ?
                                this._showCancelOrder : null}
                              checkout={checkout}
                              className={styles.checkoutCard}
                            />
                          );
                        })
                      }
                    </div>
                  }
                </div>
              }
              {
                dataLoaded && !!CheckoutStore.actualCheckouts &&
                CheckoutStore.actualCheckouts.length === 0 && !!CheckoutStore.pastCheckouts &&
                CheckoutStore.pastCheckouts.length === 0 &&
                <p>No hay compras para mostrar</p>
              }
              {
                ((!dataLoaded &&
                !CheckoutStore.getError) || (!dataLoaded &&
                !CheckoutStore.creationError)) &&
                <Spinner className={styles.spinner} />
              }
              {
                !dataLoaded &&
                CheckoutStore.getError &&
                <p className={styles.errorMessage}>
                  Ha ocurrido un error, por favor inténtelo nuevamente.
                </p>
              }
              {
                this.state.showCancelModal &&
                <Modal>
                  <div className={styles.modalChildren}>
                    {
                      CheckoutStore.creationError &&
                      <div>
                        <p className={styles.modalError}>
                          Ha ocurrido un error, por favor intente nuevamente.
                        </p>
                        <SimpleButton
                          onClick={this._toggleErrorButton}
                          className={styles.messageModalButton}
                        >
                          Volver
                        </SimpleButton>
                      </div>
                    }
                    {
                      CheckoutStore.cancelError &&
                      <div>
                        <p className={styles.modalError}>
                          Ha ocurrido un error, por favor intente nuevamente.
                        </p>
                        <SimpleButton
                          onClick={this._toggleErrorButton}
                          className={styles.messageModalButton}
                        >
                          Volver
                        </SimpleButton>
                      </div>
                    }
                    {
                      CheckoutStore.cancelInternalError &&
                      <div>
                        <p className={styles.modalError}>
                          Estamos experimentando algunas dificultades en nuestro sitio.
                          Por favor intente nuevamente en unos momentos.
                        </p>
                        <SimpleButton
                          onClick={this._toggleErrorButton}
                          className={styles.messageModalButton}
                        >
                          Volver
                        </SimpleButton>
                      </div>
                    }
                    {
                      CheckoutStore.cancelApiError &&
                      <div>
                        <p className={styles.modalError}>
                          {
                            CheckoutStore.cancelApiError === ERROR_CODES.INVALID_CHECKOUT_PARAMS &&
                            'No es posible realizar esta acción para este pedido'
                          }
                          {
                            CheckoutStore.cancelApiError
                            === ERROR_CODES.CHECKOUT_BILLED_OR_CANCELED &&
                            'Este pedido ya fue facturado o anulado'
                          }
                        </p>
                        <SimpleButton
                          onClick={this._toggleErrorButton}
                          className={styles.messageModalButton}
                        >
                          Volver
                        </SimpleButton>
                      </div>
                    }
                    {
                      CheckoutStore.cancelSuccess &&
                      <div>
                        <p className={styles.modalSuccess}>
                          Pedido cancelado con éxito
                        </p>
                        <SimpleButton
                          onClick={this._toggleSuccessButton}
                          className={styles.messageModalButton}
                        >
                          Volver
                        </SimpleButton>
                      </div>
                    }
                    {
                      CheckoutStore.cancellingCheckout &&
                      <Spinner className={styles.modalSpinner} />
                    }
                    {
                      !CheckoutStore.cancelInternalError &&
                      !CheckoutStore.cancelApiError &&
                      !CheckoutStore.cancelError &&
                      !CheckoutStore.cancellingCheckout &&
                      !CheckoutStore.cancelSuccess &&
                      !CheckoutStore.creationError &&
                      <div>
                        <p className={styles.modalQuestion}>
                          ¿Está seguro de que desea cancelar el pedido?
                        </p>
                        <p className={styles.modalText}>
                          Esta operación no puede deshacerse.
                        </p>
                        <div className={mobileVersion ?
                          styles.mobileButtonsSection : styles.buttonsSection}
                        >
                          <SimpleButton
                            className={styles.hideButton}
                            onClick={this._closeCancelModal}
                          >
                            Volver
                          </SimpleButton>
                          <SimpleButton
                            className={styles.cancelButton}
                            onClick={this._cancelCheckout}
                          >
                            Cancelar pedido
                          </SimpleButton>
                        </div>
                      </div>
                    }
                  </div>
                </Modal>
              }
            </div>
          </div>
        </div>
        {this.state.paramsBank &&
          <form method="POST" action={process.env.REACT_APP_SISTARBANK_URL}>
            <input type="hidden" name="idBanco" value={this.state.paramsBank.idBanco} />
            <input type="hidden" name="idTransaccion" value={this.state.paramsBank.idTransaccion} />
            <input type="hidden" name="idOrganismo" value={this.state.paramsBank.idOrganismo} />
            <input type="hidden" name="tipoServicio" value={this.state.paramsBank.tipoServicio} />
            <input type="hidden" name="idCuenta" value={this.state.paramsBank.idCuenta} />
            <input type="hidden" name="idFactura" value={this.state.paramsBank.idFactura} />
            <input type="hidden" name="importe" value={this.state.paramsBank.importe} />
            <input type="hidden" name="importeGravado" value={this.state.paramsBank.importeGravado} />
            <input type="hidden" name="consumidorFinal" value={this.state.paramsBank.consumidorFinal} />
            <input type="hidden" name="moneda" value={this.state.paramsBank.moneda} />
            <input type="hidden" name="urlVuelta" value={process.env.REACT_APP_GOBACK_URL} />
            <input ref={this.buttonBank} type="submit" value="Enviar" style={{ opacity: 0 }} />
          </form>
        }
        <Footer />
      </div>
    );
  }
}

const ObservableMyOrders = observer(MyOrders);

export { ObservableMyOrders as MyOrders };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-orders/MyOrders.jsx